"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'row',
      alignContent: 'center',
      alignItems: 'center',
      justifyContent: 'center',
      justifyItems: 'center'
    },
    'height-auto': {
      height: 'auto'
    },
    s40: {
      height: theme.spacing(40)
    },
    s60: {
      height: theme.spacing(60)
    },
    'custom-height': {
      height: function height(props) {
        return props.size;
      }
    }
  };
}, {
  name: 'SxWebJumbotronSlide'
});

function JumbotronSlide(_ref) {
  var _sizeClasses;

  var children = _ref.children,
      pClasses = _ref.classes,
      className = _ref.className,
      size = _ref.size,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "className", "size"]);
  var classes = useStyles({
    classes: pClasses,
    size: size
  });
  var sizeClasses = (_sizeClasses = {}, (0, _defineProperty2.default)(_sizeClasses, classes['height-auto'], size === 'auto'), (0, _defineProperty2.default)(_sizeClasses, classes.s40, size === 's40'), (0, _defineProperty2.default)(_sizeClasses, classes.s60, size === 's60'), (0, _defineProperty2.default)(_sizeClasses, classes['custom-height'], typeof size === 'number'), _sizeClasses);
  return _react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className, sizeClasses)
  }), children);
}

JumbotronSlide.propTypes = {
  children: _propTypes.default.node,
  classes: _propTypes.default.shape({
    'custom-height': _propTypes.default.string,
    'height-auto': _propTypes.default.string,
    root: _propTypes.default.string,
    s40: _propTypes.default.string,
    s60: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  size: _propTypes.default.oneOfType([_propTypes.default.number, // pro vysku v px
  _propTypes.default.oneOf(['auto', 's40', 's60'])])
};
JumbotronSlide.defaultProps = {
  children: null,
  classes: undefined,
  className: undefined,
  size: 'auto'
};
var _default = JumbotronSlide;
exports.default = _default;